import { initializeApp, getApps, type FirebaseApp } from 'firebase/app'
import {
  getAuth,
  GoogleAuthProvider,
  FacebookAuthProvider,
  signInWithPopup,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  updateProfile,
  signOut,
  onAuthStateChanged,
  setPersistence,
  browserLocalPersistence,
  browserSessionPersistence,
  type User,
  type Auth,
} from 'firebase/auth'

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY as string,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN as string,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID as string,
}

// Prevent re-initialization on Vite hot reload
export const app: FirebaseApp = getApps().length ? getApps()[0]! : initializeApp(firebaseConfig)
export const auth: Auth = getAuth(app)

export const googleProvider = new GoogleAuthProvider()
export const facebookProvider = new FacebookAuthProvider()

export const signInWithGoogle = () => signInWithPopup(auth, googleProvider)
export const signInWithFacebook = () => signInWithPopup(auth, facebookProvider)

export const signInWithEmail = (email: string, password: string) =>
  signInWithEmailAndPassword(auth, email, password)

export const createUserWithEmail = async (email: string, password: string, displayName: string) => {
  const credential = await createUserWithEmailAndPassword(auth, email, password)
  await updateProfile(credential.user, { displayName })
  return credential
}

export const setAuthPersistence = (persistent: boolean) =>
  setPersistence(auth, persistent ? browserLocalPersistence : browserSessionPersistence)

export const logout = () => signOut(auth)

export const onAuthChange = (cb: (user: User | null) => void) =>
  onAuthStateChanged(auth, cb)
